import _ from "lodash";

const defaultState = {
  isPackageLoading: true,
  packages: [],
};

export default function motorReducer(state = defaultState, data = {}) {
  return {
    ...state,
    ...data
  };
}
